import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Tooltip, Table, LoadingIndicator } from '@components';
import { useSelector } from 'react-redux';
import { AlteracaoPerfilService } from '@services/alteracao-perfil';

export const HistoricoIntencaoMudancaPerfil = () => {
  const users = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const getHistoricoIntencaoTroca = useCallback(async () => {
    setLoading(true);
    const historicoIntencaoService = new AlteracaoPerfilService();
    const historicoIntencaoTroca =
      await historicoIntencaoService.getHistoricoIntencaoTrocaPerfilParticipante(
        users.matricula
      );
    setHistorico(historicoIntencaoTroca);
    setLoading(false);
  }, [users.matricula]);

  useEffect(() => {
    getHistoricoIntencaoTroca();
  }, [getHistoricoIntencaoTroca]);

  return !loading ? (
    <>
      <Helmet>
        <title>Histórico de Intenção de Mudança de Perfil</title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico de Intenção de Mudança de Perfil
            <Tooltip title="Veja o histórico de intenção de mudança de perfil">
              ?
            </Tooltip>
          </span>
          <Table
            className=" mb-4 mt-32"
            odd
            columns={[
              'Data Solicitação',
              'Perfil Atual',
              'Perfil Solicitado',
              'Data Hora Registro',
              'Autor Registro',
            ]}
          >
            {historico.map((linha) => {
              return (
                <tr key={linha.DataHoraRegistro}>
                  <td>{linha.DataSolicitacao}</td>
                  <td>{linha.PerfilVigente}</td>
                  <td>{linha.PerfilDesejado}</td>
                  <td>{linha.DataHoraRegistro}</td>
                  <td>{linha.AutorRegistro}</td>
                </tr>
              );
            })}
          </Table>
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
